export class CommentCategoryIds {
  public static readonly IntakeAssessmentCode = 'Intake Assessment';
  public static readonly EmploymentReadinessCode = 'era';
  public static readonly ASCCCode = 'asccContact';
  public static readonly ISCCCode = 'isccContact';
  public static readonly ChildSupportServicesCode = 'childSupportServices';
  public static readonly ServiceProviderCode = 'Service Provider';
  public static readonly ActionPlanCode = 'ActionPlan';
  public static readonly PrimeContractorCode = 'primeContractor';
}
